import { ROUTES } from '@/app/lib/constants'
import { SearchCoursesPage } from '@/app/modules/search/pages/SearchCoursesPage'
import { ApiService } from '@/app/services/ApiService'
import { CourseService } from '@/app/services/courses'
import { ICategory } from '@/types/category'
import { IEducationProvider } from '@/types/education-provider'
import { isBoom } from '@hapi/boom'

const cookieName = process.env.NEXT_PUBLIC_AUTH_COOKIE_NAME

export async function getServerSideProps(context) {
  const { req, query, locale } = context
  const { page = 1, limit = 16, ...filters } = query

  try {
    ApiService.setAccessToken(req.cookies?.[cookieName!] || '')
    ApiService.setHeader('accept-language', locale ?? 'en')

    const initialCoursesResponse = await CourseService.getCourses(
      {
        ...filters,
      },
      {
        page,
        limit,
      },
      {
        qualityScore: 'desc',
        random: 'desc',
      }
    )

    let filterTitle = ''

    if (initialCoursesResponse.data.length > 0) {
      const { educationProvider, categories = [] } =
        initialCoursesResponse.data[0]
      if (
        Array.isArray(filters.educationProvider) &&
        filters.educationProvider.length === 1 &&
        educationProvider
      ) {
        filterTitle = (educationProvider as IEducationProvider).name
      } else if (filters.categories) {
        filterTitle =
          (categories as ICategory[]).find(
            (category) =>
              category._id ===
              (Array.isArray(filters.categories)
                ? filters.categories[0]
                : filters.categories)
          )?.name ?? ''
      }
    }

    return {
      props: {
        initialCoursesResponse: {
          pages: [initialCoursesResponse],
          pageParams: [page],
        },
        filterTitle,
        initialQueryParams: {
          page,
          limit,
          ...filters,
        },
        messages: {
          ...(await import(`@/locales/${context.locale}/navigation.json`))
            .default,
          ...(await import(`@/locales/${context.locale}/strings.json`)).default,
        },
      },
    }
  } catch (e) {
    console.error(e)
    if (isBoom(e, 401)) {
      return {
        redirect: {
          destination: ROUTES.logout,
          permanent: false,
          locale,
        },
      }
    } else if (isBoom(e, 403)) {
      return {
        redirect: {
          destination: `/${locale}${ROUTES.accessDenied}`,
          permanent: false,
          locale,
        },
      }
    }

    throw e
  }
}

export default SearchCoursesPage
